<template>
  <div class="limiter">
    <div class="container-login100">
      <div class="wrap-login100">
        <div class="login100-form-title">
          <span class="login100-form-title-1">云 享 优 量</span>
        </div>
        <div class="login100-form-box">
          <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            label-width="80px"
            :size="size"
          >
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="loginForm.email" placeholder="请填写登录邮箱"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input show-password v-model="loginForm.password" placeholder="请填写登录密码"></el-input>
            </el-form-item>

            <el-form-item label="验证码" prop="captcha">
              <div @click="getVerify()">
                <img :src="captchaImage" alt="验证码" width="100%" />
                <!-- <el-image :src="captchaImage" alt="验证码" width="100%" /> -->
              </div>
              <el-input v-model="loginForm.captcha" placeholder="请填写验证码"></el-input>
            </el-form-item>
            <div class="container-login100-form-btn">
              <el-button type="primary" @click="login('loginForm')">登 录</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loginForm: {
        email: '',
        password: '',
        captcha: ''
      },
      loginRules: {
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      captchaImage: '',
      size: 'big'
    }
  },
  beforeMount: function() {
    this.getVerify()
  },
  methods: {
    getVerify: function() {
      this.$api.http.post('login/getVerify').then(res => {
        let blob = new Blob([res], { type: 'image/png' })
        this.captchaImage = window.URL.createObjectURL(blob)
      })
    },
    login: function(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.$api.http.post('login/login', this.loginForm).then(res => {
            if (res && res.code == 0) {
              // localStorage.setItem('SESSIONID', res.data)
              localStorage.setItem('py_token', res.data)
              this.$router.replace('/')
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: 'error'
              })
              this.getVerify()
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container-login100 {
  background: url(../assets/images/login_bg.jpg) no-repeat center;
  background-size: cover;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.wrap-login100 {
  width: 500px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.login100-form-title {
  width: 100%;
  position: relative;
  z-index: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  box-sizing: border-box;
  padding: 70px 15px 74px 15px;
  background: url(../assets/images/bg-01.jpg);
}

.login100-form-title-1 {
  font-family: Poppins-Bold;
  font-size: 35px;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;
  line-height: 1.2;
  text-align: center;
}

.login100-form-title::before {
  content: '';
  display: block;
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(54, 84, 99, 0.7);
}
.login100-form-box {
  padding: 25px 45px 25px 25px;
}
.container-login100-form-btn {
  text-align: center;
}
</style>